import { render, staticRenderFns } from "./printaccountledger.vue?vue&type=template&id=24f6d570"
import script from "./printaccountledger.vue?vue&type=script&lang=js"
export * from "./printaccountledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports